import type { ReactNode } from "react";

const SAMPLE_STATEMENT_URL = "/sample_statement";

type SamplePDFLinkProps = {
  children?: ReactNode;
  onConfirmedEstatementAccess: (confirmed: boolean) => void;
};

const SamplePDFLink = ({
  children = null,
  onConfirmedEstatementAccess
}: SamplePDFLinkProps) => (
  <a
    href={SAMPLE_STATEMENT_URL}
    target="_blank"
    rel="noreferrer"
    onClick={() => onConfirmedEstatementAccess(true)}
    className="fontWeight--semibold"
  >
    {children}
  </a>
);

export default SamplePDFLink;
